export function formatRangeCheck(check) {
  if (check.min === check.max) {
    return `expected value: ${check.min}, actual: ${check.actual}`;
  }
  const lowerBound = typeof check.min === "number" ? `${check.min} <= ` : "";
  const upperBound = typeof check.max === "number" ? ` <= ${check.max}` : "";
  return `expected value: ${lowerBound}actual${upperBound}, actual: ${check.actual}`;
}
